import React from 'react';
import '../template-file-css/document-file-template.css';


export const WFS_NeedsAndStrengths = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='WFS_NeedsAndStrengths' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><b>For the Needs Domains, use the following categories and action levels:</b>
                    <br />
                    <b>0-</b>No evidence of any needs; no need for action.
                    <br />
                    <b>1-</b>Identified need that requires monitoring, watchful waiting, or preventive action based on history, suspicion or disagreement.
                    <br />
                    <b>2-</b>Action is required to ensure that the identified need is addressed; need is interfering with functioning.
                    <br />
                    <b>3-</b>Need is dangerous or disabling; requires immediate and/or intensive action.
                </p>

                <p className='w-750'><span className='eleHeader'>LIFE DOMAIN FUNCTIONING</span>
                </p>

                <table>
                    <tr>
                        <td className='w-450'> Family Functioning </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyFunctioning_0' name='rbFamilyFunctioning' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyFunctioning_1' name='rbFamilyFunctioning' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyFunctioning_2' name='rbFamilyFunctioning' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyFunctioning_3' name='rbFamilyFunctioning' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Sleep </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSleep_0' name='rbSleep' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSleep_1' name='rbSleep' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSleep_2' name='rbSleep' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSleep_3' name='rbSleep' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Medical/Physical (A) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedical_0' name='rbMedical' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedical_1' name='rbMedical' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedical_2' name='rbMedical' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedical_3' name='rbMedical' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Basic Activities of Daily Living </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBasicActivities_0' name='rbBasicActivities' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBasicActivities_1' name='rbBasicActivities' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBasicActivities_2' name='rbBasicActivities' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBasicActivities_3' name='rbBasicActivities' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Employment Functioning (B) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmploymentFunctioning_0' name='rbEmploymentFunctioning' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmploymentFunctioning_1' name='rbEmploymentFunctioning' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmploymentFunctioning_2' name='rbEmploymentFunctioning' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmploymentFunctioning_3' name='rbEmploymentFunctioning' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Medication Adherence </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedicationAdherence_0' name='rbMedicationAdherence' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedicationAdherence_1' name='rbMedicationAdherence' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedicationAdherence_2' name='rbMedicationAdherence' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedicationAdherence_3' name='rbMedicationAdherence' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Social Functioning </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocialFunctioning_0' name='rbSocialFunctioning' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocialFunctioning_1' name='rbSocialFunctioning' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocialFunctioning_2' name='rbSocialFunctioning' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocialFunctioning_3' name='rbSocialFunctioning' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Transportation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTransportation_0' name='rbTransportation' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTransportation_1' name='rbTransportation' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTransportation_2' name='rbTransportation' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTransportation_3' name='rbTransportation' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Recreational </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecreational_0' name='rbRecreational' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecreational_1' name='rbRecreational' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecreational_2' name='rbRecreational' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecreational_3' name='rbRecreational' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Living Situation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLivingSituation_0' name='rbLivingSituation' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLivingSituation_1' name='rbLivingSituation' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLivingSituation_2' name='rbLivingSituation' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLivingSituation_3' name='rbLivingSituation' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Developmental/Intellectual (C) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntellectual_0' name='rbIntellectual' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntellectual_1' name='rbIntellectual' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntellectual_2' name='rbIntellectual' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntellectual_3' name='rbIntellectual' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> School </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSchool_0' name='rbSchool' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSchool_1' name='rbSchool' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSchool_2' name='rbSchool' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSchool_3' name='rbSchool' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Sexuality </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexuality_0' name='rbSexuality' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexuality_1' name='rbSexuality' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexuality_2' name='rbSexuality' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexuality_3' name='rbSexuality' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Decision Making </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDecisionMaking_0' name='rbDecisionMaking' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDecisionMaking_1' name='rbDecisionMaking' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDecisionMaking_2' name='rbDecisionMaking' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDecisionMaking_3' name='rbDecisionMaking' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Independent Living Skills </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIndependent_0' name='rbIndependent' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIndependent_1' name='rbIndependent' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIndependent_2' name='rbIndependent' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIndependent_3' name='rbIndependent' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Involvement in Recovery </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvement_0' name='rbInvolvement' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvement_1' name='rbInvolvement' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvement_2' name='rbInvolvement' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvement_3' name='rbInvolvement' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Residential Stability </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResidential_0' name='rbResidential' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResidential_1' name='rbResidential' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResidential_2' name='rbResidential' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResidential_3' name='rbResidential' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Parental/Caregiving Role (D) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParental_0' name='rbParental' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParental_1' name='rbParental' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParental_2' name='rbParental' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParental_3' name='rbParental' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Legal </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegal_0' name='rbLegal' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegal_1' name='rbLegal' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegal_2' name='rbLegal' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegal_3' name='rbLegal' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`A. MEDICAL HEALTH MODULE (To complete when the Medical/Physical item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                    <tr>
                        <td className='w-450'> MH1. Management of Health Care </td>
                        <td className='w-75'>
                            <input type='radio' id='rbManagement_0' name='rbManagement' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbManagement_1' name='rbManagement' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbManagement_2' name='rbManagement' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbManagement_3' name='rbManagement' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH2. Coordination of Health Care </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCoordination_0' name='rbCoordination' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCoordination_1' name='rbCoordination' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCoordination_2' name='rbCoordination' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCoordination_3' name='rbCoordination' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH3. Organizational Complexity </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganizational_0' name='rbOrganizational' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganizational_1' name='rbOrganizational' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganizational_2' name='rbOrganizational' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganizational_3' name='rbOrganizational' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH4. Medication Management </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedication_0' name='rbMedication' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedication_1' name='rbMedication' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedication_2' name='rbMedication' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMedication_3' name='rbMedication' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH5. Intensity of Treatment </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntensity_0' name='rbIntensity' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntensity_1' name='rbIntensity' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntensity_2' name='rbIntensity' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntensity_3' name='rbIntensity' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH6. Chronicity </td>
                        <td className='w-75'>
                            <input type='radio' id='rbChronicity_0' name='rbChronicity' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbChronicity_1' name='rbChronicity' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbChronicity_2' name='rbChronicity' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbChronicity_3' name='rbChronicity' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH7. Life Threatening </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLifeThreatening_0' name='rbLifeThreatening' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLifeThreatening_1' name='rbLifeThreatening' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLifeThreatening_2' name='rbLifeThreatening' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLifeThreatening_3' name='rbLifeThreatening' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH8. Diagnostic Complexity </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDiagnostic_0' name='rbDiagnostic' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDiagnostic_1' name='rbDiagnostic' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDiagnostic_2' name='rbDiagnostic' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDiagnostic_3' name='rbDiagnostic' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH9. Impairment in Functioning </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpairment_0' name='rbImpairment' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpairment_1' name='rbImpairment' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpairment_2' name='rbImpairment' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpairment_3' name='rbImpairment' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH10. Emotional Response </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmotional_0' name='rbEmotional' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmotional_1' name='rbEmotional' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmotional_2' name='rbEmotional' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEmotional_3' name='rbEmotional' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> MH11. Family Stress (Optional) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMhFamilyStress_0' name='rbMhFamilyStress' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMhFamilyStress_1' name='rbMhFamilyStress' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMhFamilyStress_2' name='rbMhFamilyStress' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMhFamilyStress_3' name='rbMhFamilyStress' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`B. RISEMPLOY MODULE Use the Strengths Rating Scale. (To complete when the Employment Functioning item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                    <tr>
                        <td className='w-450'> RISE1. Career Aspirations </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCareer_0' name='rbCareer' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCareer_1' name='rbCareer' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCareer_2' name='rbCareer' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCareer_3' name='rbCareer' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE2. Aspirational Congruence </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirational_0' name='rbAspirational' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirational_1' name='rbAspirational' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirational_2' name='rbAspirational' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirational_3' name='rbAspirational' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE3. Labor Market Expectations </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLaborMarket_0' name='rbLaborMarket' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLaborMarket_1' name='rbLaborMarket' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLaborMarket_2' name='rbLaborMarket' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLaborMarket_3' name='rbLaborMarket' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE4. Work Ethic </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkEthic_0' name='rbWorkEthic' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkEthic_1' name='rbWorkEthic' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkEthic_2' name='rbWorkEthic' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkEthic_3' name='rbWorkEthic' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE5. Work History </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkHistory_0' name='rbWorkHistory' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkHistory_1' name='rbWorkHistory' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkHistory_2' name='rbWorkHistory' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWorkHistory_3' name='rbWorkHistory' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE6. Time Since Last Job </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLastJob_0' name='rbLastJob' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLastJob_1' name='rbLastJob' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLastJob_2' name='rbLastJob' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLastJob_3' name='rbLastJob' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE7. Job Turnover  </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobTurnover_0' name='rbJobTurnover' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobTurnover_1' name='rbJobTurnover' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobTurnover_2' name='rbJobTurnover' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobTurnover_3' name='rbJobTurnover' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE8. Job Attendance  </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobAttendance_0' name='rbJobAttendance' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobAttendance_1' name='rbJobAttendance' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobAttendance_2' name='rbJobAttendance' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobAttendance_3' name='rbJobAttendance' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE9. Job Performance </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobPerformance_0' name='rbJobPerformance' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobPerformance_1' name='rbJobPerformance' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobPerformance_2' name='rbJobPerformance' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobPerformance_3' name='rbJobPerformance' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE10. Job Relations </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobRelations_0' name='rbJobRelations' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobRelations_1' name='rbJobRelations' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobRelations_2' name='rbJobRelations' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobRelations_3' name='rbJobRelations' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE11. Job Enjoyment </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobEnjoyment_0' name='rbJobEnjoyment' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobEnjoyment_1' name='rbJobEnjoyment' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobEnjoyment_2' name='rbJobEnjoyment' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobEnjoyment_3' name='rbJobEnjoyment' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE12. Consumer Orientation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsumer_0' name='rbConsumer' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsumer_1' name='rbConsumer' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsumer_2' name='rbConsumer' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsumer_3' name='rbConsumer' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE13. Routine  </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRoutine_0' name='rbRoutine' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRoutine_1' name='rbRoutine' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRoutine_2' name='rbRoutine' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRoutine_3' name='rbRoutine' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE14. Skills Relev. to Aspirations  </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirations_0' name='rbAspirations' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirations_1' name='rbAspirations' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirations_2' name='rbAspirations' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAspirations_3' name='rbAspirations' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE15. Digital Literacy </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDigital_0' name='rbDigital' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDigital_1' name='rbDigital' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDigital_2' name='rbDigital' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDigital_3' name='rbDigital' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE16. Financial Literacy </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFinancial_0' name='rbFinancial' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFinancial_1' name='rbFinancial' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFinancial_2' name='rbFinancial' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFinancial_3' name='rbFinancial' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE17. Resume/Cover letter </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResume_0' name='rbResume' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResume_1' name='rbResume' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResume_2' name='rbResume' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResume_3' name='rbResume' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> RISE18. Interview Clothes </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterview_0' name='rbInterview' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterview_1' name='rbInterview' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterview_2' name='rbInterview' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterview_3' name='rbInterview' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`C. DEVELOPMENTAL NEEDS MODULE (To complete when the Developmental/Intellectual item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                    <tr>
                        <td className='w-450'> DN1. Cognitive </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCognitive_0' name='rbCognitive' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCognitive_1' name='rbCognitive' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCognitive_2' name='rbCognitive' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCognitive_3' name='rbCognitive' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DN2. Communication </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunication_0' name='rbCommunication' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunication_1' name='rbCommunication' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunication_2' name='rbCommunication' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunication_3' name='rbCommunication' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DN3. Developmental </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDnDevelopmental_0' name='rbDnDevelopmental' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDnDevelopmental_1' name='rbDnDevelopmental' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDnDevelopmental_2' name='rbDnDevelopmental' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDnDevelopmental_3' name='rbDnDevelopmental' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`D. PARENTING/CAREGIVING MODULE (To complete when the Parental/Caregiving Role item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                    <tr>
                        <td className='w-450'> PC1. Knowledge of Needs </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledgeOfNeeds_0' name='rbKnowledgeOfNeeds' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledgeOfNeeds_1' name='rbKnowledgeOfNeeds' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledgeOfNeeds_2' name='rbKnowledgeOfNeeds' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledgeOfNeeds_3' name='rbKnowledgeOfNeeds' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> PC2. Supervision </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSupervision_0' name='rbSupervision' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSupervision_1' name='rbSupervision' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSupervision_2' name='rbSupervision' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSupervision_3' name='rbSupervision' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> PC3. Involvement with Care </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementCare_0' name='rbInvolvementCare' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementCare_1' name='rbInvolvementCare' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementCare_2' name='rbInvolvementCare' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementCare_3' name='rbInvolvementCare' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> PC4. Organization </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPcOrganization_0' name='rbPcOrganization' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPcOrganization_1' name='rbPcOrganization' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPcOrganization_2' name='rbPcOrganization' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPcOrganization_3' name='rbPcOrganization' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> PC5. Marital/Partner Viol. In the Home </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMarital_0' name='rbMarital' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMarital_1' name='rbMarital' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMarital_2' name='rbMarital' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMarital_3' name='rbMarital' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Please write a rationale for any item in the previous domain or modules rated actionable (‘2’ or ‘3’).`}</span>
                    <textarea id='txtParenting' name='txtParenting' className='add-only'></textarea>
                </p>

                <p className='w-750'>Mr. Quincy is diagnosed with Schizophrenia and presents with symptoms of auditory hallucinations, irritability, and difficulty functioning in multiple areas including employment, socializing with others and the ability to live on his own. Mr. Quincy's mother stated he was described as having low processing abilities by a psychiatrist when he was younger.
                </p>

                <p className='w-750'><span className='eleHeader'>For the Strengths Domain, use the following categories and action levels:</span>
                    <br />
                    <b>0-</b>{`Well-developed, centerpiece strength; may be used as a centerpiece in an intervention/action plan`}
                    <br />
                    <b>1-</b>{`Identified and useful strength. Strength will be used, maintained or built upon as part of the plan. May require some effort to develop strength into a centerpiece strength`}
                    <br />
                    <b>2-</b>{`Strengths have been identified but require strength-building efforts before they can be effectively utilized as part of a plan. Identified but not useful.`}
                    <br />
                    <b>3-</b>{`An area in which no current strength is identified; efforts may be recommended to develop a strength in this area.`}
                </p>

                <p className='w-750'><span className='eleHeader'>STRENGTHS DOMAIN</span></p>

                <table>
                    <tr>
                        <td className='w-450'> Family Strengths </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStrengths_0' name='rbStrengths' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStrengths_1' name='rbStrengths' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStrengths_2' name='rbStrengths' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStrengths_3' name='rbStrengths' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Interpersonal/Social Connectedness </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConnectedness_0' name='rbConnectedness' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConnectedness_1' name='rbConnectedness' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConnectedness_2' name='rbConnectedness' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConnectedness_3' name='rbConnectedness' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Optimism </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOptimism_0' name='rbOptimism' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOptimism_1' name='rbOptimism' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOptimism_2' name='rbOptimism' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOptimism_3' name='rbOptimism' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Job History </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobHistory_0' name='rbJobHistory' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobHistory_1' name='rbJobHistory' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobHistory_2' name='rbJobHistory' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbJobHistory_3' name='rbJobHistory' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Talents and Interests </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTalents_0' name='rbTalents' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTalents_1' name='rbTalents' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTalents_2' name='rbTalents' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTalents_3' name='rbTalents' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Spiritual/Religious </td>
                        <td className='w-75'>
                            <input type='radio' id='rbReligious_0' name='rbReligious' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbReligious_1' name='rbReligious' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbReligious_2' name='rbReligious' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbReligious_3' name='rbReligious' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Community Connection </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunity_0' name='rbCommunity' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunity_1' name='rbCommunity' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunity_2' name='rbCommunity' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunity_3' name='rbCommunity' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Natural Supports </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNatural_0' name='rbNatural' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNatural_1' name='rbNatural' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNatural_2' name='rbNatural' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNatural_3' name='rbNatural' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Resilience </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResilience_0' name='rbResilience' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResilience_1' name='rbResilience' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResilience_2' name='rbResilience' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResilience_3' name='rbResilience' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Resourcefulness </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResourcefulness_0' name='rbResourcefulness' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResourcefulness_1' name='rbResourcefulness' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResourcefulness_2' name='rbResourcefulness' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbResourcefulness_3' name='rbResourcefulness' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Volunteering </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVolunteering_0' name='rbVolunteering' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVolunteering_1' name='rbVolunteering' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVolunteering_2' name='rbVolunteering' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVolunteering_3' name='rbVolunteering' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Educational/Vocational </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVocational_0' name='rbVocational' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVocational_1' name='rbVocational' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVocational_2' name='rbVocational' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVocational_3' name='rbVocational' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Cultural Identity </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalIdentity_0' name='rbCulturalIdentity' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalIdentity_1' name='rbCulturalIdentity' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalIdentity_2' name='rbCulturalIdentity' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalIdentity_3' name='rbCulturalIdentity' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Please write a rationale for Centerpiece (‘0’) and Useful (‘1’) Strengths, as well as Strengths to Build (‘2’ or ‘3’).`}</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>{`Mr. Quincy has identified strengths, talents, spiritual beliefs, connections to the community, and job history. Due to his diagnosis and level of impairment, he has limited educational and employment options.`}
                </p>

                <p className='w-750'><span className='eleHeader'>For the Needs Domains, use the following categories and action levels:</span>
                    <br />
                    <b>0-</b>{`No evidence of any needs; no need for action.`}
                    <br />
                    <b>1-</b>{`Identified need that requires monitoring, watchful waiting, or preventive action based on history, suspicion or disagreement.`}
                    <br />
                    <b>2-</b>{`Action is required to ensure that the identified need is addressed; need is interfering with functioning.`}
                    <br />
                    <b>3-</b>{`Need is dangerous or disabling; requires immediate and/or intensive action.`}
                </p>

                <p className='w-750'><span className='eleHeader'>CULTURAL FACTORS DOMAIN</span></p>

                <table>
                    <tr>
                        <td className='w-450'> Language </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLanguage_0' name='rbLanguage' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLanguage_1' name='rbLanguage' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLanguage_2' name='rbLanguage' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLanguage_3' name='rbLanguage' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Traditions and Rituals </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraditions_0' name='rbTraditions' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraditions_1' name='rbTraditions' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraditions_2' name='rbTraditions' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraditions_3' name='rbTraditions' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Cultural Stress </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalStress_0' name='rbCulturalStress' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalStress_1' name='rbCulturalStress' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalStress_2' name='rbCulturalStress' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCulturalStress_3' name='rbCulturalStress' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Please write a rationale for any item in the above domain rated actionable (‘2’ or ‘3’).`}</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>BEHAVIORAL/EMOTIONAL NEEDS DOMAIN</span></p>

                <table>
                    <tr>
                        <td className='w-450'> Psychosis (Thought Disorder) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPsychosis_0' name='rbPsychosis' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPsychosis_1' name='rbPsychosis' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPsychosis_2' name='rbPsychosis' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPsychosis_3' name='rbPsychosis' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Impulse Control </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpulseControl_0' name='rbImpulseControl' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpulseControl_1' name='rbImpulseControl' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpulseControl_2' name='rbImpulseControl' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbImpulseControl_3' name='rbImpulseControl' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Depression </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDepression_0' name='rbDepression' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDepression_1' name='rbDepression' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDepression_2' name='rbDepression' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDepression_3' name='rbDepression' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Mood Disturbance </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMoodDisturbance_0' name='rbMoodDisturbance' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMoodDisturbance_1' name='rbMoodDisturbance' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMoodDisturbance_2' name='rbMoodDisturbance' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbMoodDisturbance_3' name='rbMoodDisturbance' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Anxiety </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAnxiety_0' name='rbAnxiety' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAnxiety_1' name='rbAnxiety' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAnxiety_2' name='rbAnxiety' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAnxiety_3' name='rbAnxiety' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Interpersonal Problems </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterpersonal_0' name='rbInterpersonal' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterpersonal_1' name='rbInterpersonal' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterpersonal_2' name='rbInterpersonal' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInterpersonal_3' name='rbInterpersonal' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Antisocial Behavior </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAntisocial_0' name='rbAntisocial' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAntisocial_1' name='rbAntisocial' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAntisocial_2' name='rbAntisocial' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAntisocial_3' name='rbAntisocial' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Adjustment to Trauma (E) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAdjustment_0' name='rbAdjustment' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAdjustment_1' name='rbAdjustment' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAdjustment_2' name='rbAdjustment' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAdjustment_3' name='rbAdjustment' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Anger Control </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAngerControl_0' name='rbAngerControl' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAngerControl_1' name='rbAngerControl' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAngerControl_2' name='rbAngerControl' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAngerControl_3' name='rbAngerControl' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Substance Use (F) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSubstanceUse_0' name='rbSubstanceUse' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSubstanceUse_1' name='rbSubstanceUse' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSubstanceUse_2' name='rbSubstanceUse' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSubstanceUse_3' name='rbSubstanceUse' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Eating Disturbances </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEating_0' name='rbEating' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEating_1' name='rbEating' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEating_2' name='rbEating' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEating_3' name='rbEating' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`E. TRAUMA MODULE (To complete when the Adjustment to Trauma item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <p className='w-750'>Potentially Traumatic/Adverse Childhood Experiences<b>No=</b>No evidence of any trauma of this type.<b>Yes=</b>Experienced or suspicion of
                </p>

                <table>
                    <tr>
                        <td className='w-550'> ACE1. Sexual Abuse </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSexualAbuse_Yes' name='rbSexualAbuse' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSexualAbuse_No' name='rbSexualAbuse' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE2. Physical Abuse </td>
                        <td className='w-100'>
                            <input type='radio' id='rbPhysicalAbuse_Yes' name='rbPhysicalAbuse' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbPhysicalAbuse_No' name='rbPhysicalAbuse' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE3.Neglect </td>
                        <td className='w-100'>
                            <input type='radio' id='rbNeglect_Yes' name='rbNeglect' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbNeglect_No' name='rbNeglect' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE4. Emotional Abuse </td>
                        <td className='w-100'>
                            <input type='radio' id='rbEmotionalAbuse_Yes' name='rbEmotionalAbuse' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbEmotionalAbuse_No' name='rbEmotionalAbuse' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE5. Medical Trauma </td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalTrauma_Yes' name='rbMedicalTrauma' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbMedicalTrauma_No' name='rbMedicalTrauma' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE6. Natural or Manmade
                        Disaster </td>
                        <td className='w-100'>
                            <input type='radio' id='rbManmadeDisaster_Yes' name='rbManmadeDisaster' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbManmadeDisaster_No' name='rbManmadeDisaster' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE7. Witness to Family
                        Violence </td>
                        <td className='w-100'>
                            <input type='radio' id='rbFamilyViolence_Yes' name='rbFamilyViolence' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbFamilyViolence_No' name='rbFamilyViolence' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE8. Witness to
                        Community/School Violence </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSchoolViolence_Yes' name='rbSchoolViolence' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSchoolViolence_No' name='rbSchoolViolence' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE9. War/Terrorism Affected </td>
                        <td className='w-100'>
                            <input type='radio' id='rbTerrorism_Yes' name='rbTerrorism' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbTerrorism_No' name='rbTerrorism' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE10. Witness /Victim to Criminal Acts </td>
                        <td className='w-100'>
                            <input type='radio' id='rbVictim_Yes' name='rbVictim' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbVictim_No' name='rbVictim' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE11. Parental Criminal Behavior </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCriminalBehavior_Yes' name='rbCriminalBehavior' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCriminalBehavior_No' name='rbCriminalBehavior' className='add-only' value='No' /> No </td>
                    </tr>
                    <tr>
                        <td className='w-550'> ACE12. Disrupt in Caregiving/Attachment Losses </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCaregiving_Yes' name='rbCaregiving' className='add-only' value='Yes' /> Yes </td>
                        <td className='w-100'>
                            <input type='radio' id='rbCaregiving_No' name='rbCaregiving' className='add-only' value='No' /> No </td>
                    </tr>
                </table>

                <p className='w-750'><b>Traumatic Stress Symptoms</b></p>

                <table>
                <tr>
                        <td className='w-450'> TSS1. Emot and/or Phys
                        Dysregulation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDysregulation_0' name='rbDysregulation' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDysregulation_1' name='rbDysregulation' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDysregulation_2' name='rbDysregulation' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDysregulation_3' name='rbDysregulation' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS2. Intrusions/Re-experiencin </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntrusions_0' name='rbIntrusions' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntrusions_1' name='rbIntrusions' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntrusions_2' name='rbIntrusions' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntrusions_3' name='rbIntrusions' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS3. Numbing </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNumbing_0' name='rbNumbing' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNumbing_1' name='rbNumbing' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNumbing_2' name='rbNumbing' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNumbing_3' name='rbNumbing' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS4. Dissociation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDissociation_0' name='rbDissociation' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDissociation_1' name='rbDissociation' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDissociation_2' name='rbDissociation' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDissociation_3' name='rbDissociation' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS5. Avoidance </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAvoidance_0' name='rbAvoidance' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAvoidance_1' name='rbAvoidance' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAvoidance_2' name='rbAvoidance' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAvoidance_3' name='rbAvoidance' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS6. Hypervigilance </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHypervigilance_0' name='rbHypervigilance' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHypervigilance_1' name='rbHypervigilance' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHypervigilance_2' name='rbHypervigilance' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHypervigilance_3' name='rbHypervigilance' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS7. Attachment Difficulties </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAttachment_0' name='rbAttachment' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAttachment_1' name='rbAttachment' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAttachment_2' name='rbAttachment' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAttachment_3' name='rbAttachment' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> TSS8. Traumatic Grief &
                        Separation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraumaticGrief_0' name='rbTraumaticGrief' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraumaticGrief_1' name='rbTraumaticGrief' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraumaticGrief_2' name='rbTraumaticGrief' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTraumaticGrief_3' name='rbTraumaticGrief' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`F. SUBSTANCE USE DISORDER MODULE (To complete when the Substance Use item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                <tr>
                        <td className='w-450'> SUD1. Severity of Use </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeverity_0' name='rbSeverity' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeverity_1' name='rbSeverity' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeverity_2' name='rbSeverity' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeverity_3' name='rbSeverity' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD2. Duration of Use </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDuration_0' name='rbDuration' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDuration_1' name='rbDuration' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDuration_2' name='rbDuration' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDuration_3' name='rbDuration' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD3. Stage of Recovery </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecovery_0' name='rbRecovery' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecovery_1' name='rbRecovery' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecovery_2' name='rbRecovery' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecovery_3' name='rbRecovery' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD4. Environmental
                        Influences </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEnvironmental_0' name='rbEnvironmental' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEnvironmental_1' name='rbEnvironmental' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEnvironmental_2' name='rbEnvironmental' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbEnvironmental_3' name='rbEnvironmental' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD5. Recovery Support in
                        Community </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecoverySupport_0' name='rbRecoverySupport' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecoverySupport_1' name='rbRecoverySupport' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecoverySupport_2' name='rbRecoverySupport' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRecoverySupport_3' name='rbRecoverySupport' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD6. Acute Intoxication </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntoxication_0' name='rbIntoxication' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntoxication_1' name='rbIntoxication' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntoxication_2' name='rbIntoxication' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntoxication_3' name='rbIntoxication' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD7. Withdrawal History </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWithdrawal_0' name='rbWithdrawal' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWithdrawal_1' name='rbWithdrawal' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWithdrawal_2' name='rbWithdrawal' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbWithdrawal_3' name='rbWithdrawal' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD8. Awareness of Relapse
                        Triggers </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelapse_0' name='rbRelapse' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelapse_1' name='rbRelapse' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelapse_2' name='rbRelapse' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelapse_3' name='rbRelapse' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SUD9. Withdrawal Risks </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRisks_0' name='rbRisks' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRisks_1' name='rbRisks' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRisks_2' name='rbRisks' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRisks_3' name='rbRisks' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Please write a rationale for any item in the above domain or modules rated actionable (‘2’ or ‘3’)`}</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>

                <p className='w-750'>Mr. Quincy experiences auditory hallucinations and mood disturbances. He is diagnosed with Schizophrenia and needs assistance with managing his emotions
                    and symptoms.</p>

                <p className='w-750'><span className='eleHeader'>RISK BEHAVIORS DOMAIN</span></p>

                <table>
                <tr>
                        <td className='w-450'> Suicide Risk (G) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSuicideRisks_0' name='rbSuicideRisks' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSuicideRisks_1' name='rbSuicideRisks' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSuicideRisks_2' name='rbSuicideRisks' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSuicideRisks_3' name='rbSuicideRisks' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Non-Suicidal Self-Injurious
                        Behavior </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNonSuicidal_0' name='rbNonSuicidal' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNonSuicidal_1' name='rbNonSuicidal' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNonSuicidal_2' name='rbNonSuicidal' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbNonSuicidal_3' name='rbNonSuicidal' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Other Self-Harm </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOther_0' name='rbOther' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOther_1' name='rbOther' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOther_2' name='rbOther' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOther_3' name='rbOther' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Victimization/Exploitation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVictimization_0' name='rbVictimization' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVictimization_1' name='rbVictimization' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVictimization_2' name='rbVictimization' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbVictimization_3' name='rbVictimization' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Danger to Others (H) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDanger_0' name='rbDanger' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDanger_1' name='rbDanger' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDanger_2' name='rbDanger' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDanger_3' name='rbDanger' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Addictive Behaviors </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAddictiveBehaviors_0' name='rbAddictiveBehaviors' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAddictiveBehaviors_1' name='rbAddictiveBehaviors' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAddictiveBehaviors_2' name='rbAddictiveBehaviors' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAddictiveBehaviors_3' name='rbAddictiveBehaviors' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Sexual Aggression (I) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAggression_0' name='rbAggression' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAggression_1' name='rbAggression' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAggression_2' name='rbAggression' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAggression_3' name='rbAggression' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Criminal Behavior (J) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCriminalBehaviorJ_0' name='rbCriminalBehaviorJ' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCriminalBehaviorJ_1' name='rbCriminalBehaviorJ' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCriminalBehaviorJ_2' name='rbCriminalBehaviorJ' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCriminalBehaviorJ_3' name='rbCriminalBehaviorJ' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`G. SUICIDE RISK MODULE (To complete when the Suicide Risk item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                <tr>
                        <td className='w-450'> SR1. Ideation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIdeation_0' name='rbIdeation' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIdeation_1' name='rbIdeation' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIdeation_2' name='rbIdeation' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIdeation_3' name='rbIdeation' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SR2. Intent </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntent_0' name='rbIntent' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntent_1' name='rbIntent' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntent_2' name='rbIntent' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbIntent_3' name='rbIntent' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SR3. Planning </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanning_0' name='rbPlanning' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanning_1' name='rbPlanning' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanning_2' name='rbPlanning' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanning_3' name='rbPlanning' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SR4. History (J) </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHistory_0' name='rbHistory' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHistory_1' name='rbHistory' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHistory_2' name='rbHistory' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHistory_3' name='rbHistory' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> {`SR5. Awareness of Others’
                        Suicide`} </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAwareness_0' name='rbAwareness' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAwareness_1' name='rbAwareness' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAwareness_2' name='rbAwareness' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAwareness_3' name='rbAwareness' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`H. DANGEROUSNESS/VIOLENCE MODULE (To complete when the Danger to Others item is rated ‘1’, ‘2’ or ‘3’.`}</span>
                </p>

                <table>
                <tr>
                        <td className='w-450'> DV1. History of Violence </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolence_0' name='rbViolence' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolence_1' name='rbViolence' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolence_2' name='rbViolence' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolence_3' name='rbViolence' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV2. Frustration
                        Management </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFrustration_0' name='rbFrustration' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFrustration_1' name='rbFrustration' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFrustration_2' name='rbFrustration' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFrustration_3' name='rbFrustration' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV3. Hostility </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHostility_0' name='rbHostility' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHostility_1' name='rbHostility' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHostility_2' name='rbHostility' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbHostility_3' name='rbHostility' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV4. Paranoid Thinking </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParanoid_0' name='rbParanoid' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParanoid_1' name='rbParanoid' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParanoid_2' name='rbParanoid' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbParanoid_3' name='rbParanoid' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV5. Secondary Gains from
                        Anger </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSecondary_0' name='rbSecondary' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSecondary_1' name='rbSecondary' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSecondary_2' name='rbSecondary' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSecondary_3' name='rbSecondary' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV6. Violent Thinking </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolentThinking_0' name='rbViolentThinking' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolentThinking_1' name='rbViolentThinking' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolentThinking_2' name='rbViolentThinking' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbViolentThinking_3' name='rbViolentThinking' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV7. Aware of Violence
                        Potential </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPotential_0' name='rbPotential' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPotential_1' name='rbPotential' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPotential_2' name='rbPotential' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPotential_3' name='rbPotential' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV8. Response to
                        Consequences </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsequences_0' name='rbConsequences' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsequences_1' name='rbConsequences' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsequences_2' name='rbConsequences' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbConsequences_3' name='rbConsequences' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV9. Commitment to Self-Contro </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommitment_0' name='rbCommitment' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommitment_1' name='rbCommitment' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommitment_2' name='rbCommitment' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommitment_3' name='rbCommitment' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> DV10. Treatment Involvement </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTreatment_0' name='rbTreatment' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTreatment_1' name='rbTreatment' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTreatment_2' name='rbTreatment' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbTreatment_3' name='rbTreatment' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`I. SEXUALLY AGGRESSIVE BEHAVIOR MODULE (To complete when the Sexual Aggression item is rated ‘1’, ‘2’ or ‘3’.`}</span>
                </p>

                <table>
                <tr>
                        <td className='w-450'> SAB1. Relationship </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelationship_0' name='rbRelationship' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelationship_1' name='rbRelationship' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelationship_2' name='rbRelationship' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbRelationship_3' name='rbRelationship' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SAB2. Physical Force/Threat </td>
                        <td className='w-75'>
                            <input type='radio' id='rbThreat_0' name='rbThreat' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbThreat_1' name='rbThreat' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbThreat_2' name='rbThreat' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbThreat_3' name='rbThreat' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SAB3. Planning Sexually
                        Aggr. Behavior </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanningSexually_0' name='rbPlanningSexually' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanningSexually_1' name='rbPlanningSexually' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanningSexually_2' name='rbPlanningSexually' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPlanningSexually_3' name='rbPlanningSexually' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SAB4. Age Differentia </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDifferentia_0' name='rbDifferentia' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDifferentia_1' name='rbDifferentia' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDifferentia_2' name='rbDifferentia' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDifferentia_3' name='rbDifferentia' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SAB5. Power Differential </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPowerDifferential_0' name='rbPowerDifferential' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPowerDifferential_1' name='rbPowerDifferential' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPowerDifferential_2' name='rbPowerDifferential' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPowerDifferential_3' name='rbPowerDifferential' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SAB6. Type of Sex Act </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexAct_0' name='rbSexAct' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexAct_1' name='rbSexAct' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexAct_2' name='rbSexAct' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSexAct_3' name='rbSexAct' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> SAB7. Response to
                        Accusation </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAccusation_0' name='rbAccusation' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAccusation_1' name='rbAccusation' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAccusation_2' name='rbAccusation' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbAccusation_3' name='rbAccusation' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`J. CRIME MODULE (To complete when the Criminal Behavior item is rated ‘1’, ‘2’ or ‘3’.)`}</span>
                </p>

                <table>
                <tr>
                        <td className='w-450'> C1. Seriousness </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeriousness_0' name='rbSeriousness' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeriousness_1' name='rbSeriousness' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeriousness_2' name='rbSeriousness' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSeriousness_3' name='rbSeriousness' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C2. Crime History </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimeHistory_0' name='rbCrimeHistory' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimeHistory_1' name='rbCrimeHistory' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimeHistory_2' name='rbCrimeHistory' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimeHistory_3' name='rbCrimeHistory' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C3. Arrests </td>
                        <td className='w-75'>
                            <input type='radio' id='rbArrests_0' name='rbArrests' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbArrests_1' name='rbArrests' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbArrests_2' name='rbArrests' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbArrests_3' name='rbArrests' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C4. Crime Planning </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePlanning_0' name='rbCrimePlanning' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePlanning_1' name='rbCrimePlanning' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePlanning_2' name='rbCrimePlanning' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePlanning_3' name='rbCrimePlanning' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C5. Community Safety </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunitySafety_0' name='rbCommunitySafety' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunitySafety_1' name='rbCommunitySafety' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunitySafety_2' name='rbCommunitySafety' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCommunitySafety_3' name='rbCommunitySafety' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C6. Legal Compliance </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegalCompliance_0' name='rbLegalCompliance' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegalCompliance_1' name='rbLegalCompliance' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegalCompliance_2' name='rbLegalCompliance' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbLegalCompliance_3' name='rbLegalCompliance' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C7. Crime Peer Influences </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePeer_0' name='rbCrimePeer' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePeer_1' name='rbCrimePeer' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePeer_2' name='rbCrimePeer' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbCrimePeer_3' name='rbCrimePeer' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> C8. Environmental Influences </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInfluences_0' name='rbInfluences' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInfluences_1' name='rbInfluences' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInfluences_2' name='rbInfluences' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInfluences_3' name='rbInfluences' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>{`Please write a rationale for any item in the above domain or modules rated actionable (‘2’ or ‘3’).`}</span>
                    <textarea id='txtrationale' name='txtrationale' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>CAREGIVER RESOURCES & NEEDS (OPTIONAL)Section Title</span>
                </p>

                <p className='w-750'><input type='radio' id='rbCaregiver_NotApplicable' name='rbCaregiver' className='add-only' value='Not applicable' /> Not applicable; no caregiver identified
                    <br />
                    <b>0-</b>No current need; no need for action. This may be a resource for the individual.
                    <br />
                    <b>1-</b>Identified need that requires monitoring, watchful waiting, or preventive action based on history, suspicion or disagreement. This may be an opportunity for resource building.
                    <br />
                    <b>2-</b>Need is interfering with the provision of care; action is required to ensure that the identified need is addressed.
                    <br />
                    <b>3-</b>Need prevents the provision of care; requires immediate and/or intensive action
                </p>

                <p className='w-750'><span className='eleHeader'>CAREGIVER RESOURCES & NEEDS DOMAIN</span>
                </p>

                <table>
                <tr>
                        <td className='w-450'> Involvement with Care </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementWithCare_0' name='rbInvolvementWithCare' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementWithCare_1' name='rbInvolvementWithCare' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementWithCare_2' name='rbInvolvementWithCare' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbInvolvementWithCare_3' name='rbInvolvementWithCare' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Knowledge </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledge_0' name='rbKnowledge' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledge_1' name='rbKnowledge' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledge_2' name='rbKnowledge' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbKnowledge_3' name='rbKnowledge' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Social Resources </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocial_0' name='rbSocial' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocial_1' name='rbSocial' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocial_2' name='rbSocial' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSocial_3' name='rbSocial' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Residential Stability </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStability_0' name='rbStability' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStability_1' name='rbStability' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStability_2' name='rbStability' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbStability_3' name='rbStability' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Medical/Physical </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPhysical_0' name='rbPhysical' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPhysical_1' name='rbPhysical' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPhysical_2' name='rbPhysical' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbPhysical_3' name='rbPhysical' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Behavioral Health </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBehavioralHealth_0' name='rbBehavioralHealth' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBehavioralHealth_1' name='rbBehavioralHealth' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBehavioralHealth_2' name='rbBehavioralHealth' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbBehavioralHealth_3' name='rbBehavioralHealth' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Developmental </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDevelopmental1_0' name='rbDevelopmental' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDevelopmental2_1' name='rbDevelopmental' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDevelopmental3_2' name='rbDevelopmental' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbDevelopmental4_3' name='rbDevelopmental' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Safety </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSafety_0' name='rbSafety' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSafety_1' name='rbSafety' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSafety_2' name='rbSafety' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbSafety_3' name='rbSafety' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Family Stress </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyStress1_0' name='rbFamilyStress' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyStress2_1' name='rbFamilyStress' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyStress3_2' name='rbFamilyStress' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbFamilyStress4_3' name='rbFamilyStress' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Organization </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganization_0' name='rbOrganization' className='add-only' value='0' /> 0 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganization_1' name='rbOrganization' className='add-only' value='1' /> 1 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganization_2' name='rbOrganization' className='add-only' value='2' /> 2 </td>
                        <td className='w-75'>
                            <input type='radio' id='rbOrganization_3' name='rbOrganization' className='add-only' value='3' /> 3
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Clinical Summary</span>
                    <textarea id='txtClinicalSummary' name='txtClinicalSummary' className='add-only'></textarea>
                </p>



                <table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>Staff Signature</td>
                    </tr>
                </table>


            </div>
        </form>

    )
} 